export default __webpack_public_path__ + "static/media/severnriver.bdbf0e9e.png";